import {useState} from "react";

export default function FormControl({label, type, value, disabled, onChange, className, ref, placeholder, variant, name, required}) {

    let [id] = useState((Math.random() + 1).toString(36).substring(7));
    const inputClassName = variant === 'onboarding'
        ? 'w-full rounded-lg border-2 border-transparent bg-white px-4 py-4 text-sm font-medium leading-[22px] text-slate-800 shadow-sm transition duration-150 ease-in-out placeholder:text-slate-400 hover:border-slate-200 focus:border-[#8470ff] focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400'
        : variant === 'modern'
            ? 'w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-800 shadow-none outline-none transition placeholder:text-slate-400 hover:border-slate-400 focus:border-violet-500 focus:ring-0 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100 dark:hover:border-slate-500 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400 dark:disabled:bg-slate-800'
            : 'form-input w-full';
    const labelClassName = variant === 'onboarding'
        ? 'mb-2 block text-sm font-medium text-slate-700'
        : variant === 'modern'
            ? 'mb-1.5 block text-sm font-medium text-slate-700 dark:text-slate-200'
            : 'block text-sm font-medium mb-1';

    return (
        <div className={className}>
            <label className={labelClassName} htmlFor={id}>{label}</label>
            <input
                id={id} className={inputClassName} value={value} type={type}
                onChange={(e) => onChange && onChange(e)}
                disabled={disabled}
                ref={ref}
                placeholder={placeholder}
                name={name}
                required={required}
            />
        </div>
    );
}
